import React, {useEffect, useState} from 'react';
import RegisterTemplate from './UserEditorTemplate';
import userService from '../../services/UserService';
import {useNavigate} from 'react-router-dom';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from "../../util/SnackbarProvider";
import cloudStorageFileService from "../../services/CloudStorageFileService";

const UserEditor = () => {

    const id = window.location.pathname.split('/')[3] === 'register' ? undefined : window.location.pathname.split('/')[3]

    useTitle([
        {name: 'Felhasználó Lista', url: '/dashboard/users'},
        {name: 'Felhasználó', url: '/dashboard/users/' + (id || 'create')}
    ])

    const [user, setUser] = useState({
        name: '',
        email: '',
        password: '',
        passwordCheck: '',
        hourlyRate: '0',
        role: 'ROLE_EMPLOYEE',
        salaryTemplate: 'NORMAL',
        monthlySzja: '0',
        yearlyDayOffs: '0',
        availableDayOffs: '0',
        monthlyFuelCost: '0',
        dailySicknessBenefitAmount: '0',
        transferredSalaryAmount: '0',
        active: true
    });

    const [message, setMessage] = useState('');
    const [files, setFiles] = useState([]);
    const {sendAlertMessage} = useSnackbar()
    const navigate = useNavigate()
    const [waitingForServer, setWaitingForServer] = useState(false)

    useEffect(() => {
        if (!id) return
        retrieveUser()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const retrieveUser = () => {
        userService.findById(id)
            .then((response) => setUser(response))
            .catch(() => sendAlertMessage('Felhasználó lekérése sikertelen', 'error'));
    }

    const onChange = (event) => {
        const {name, value} = event.target;
        setUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
    };

    const register = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        if (user.password !== user.passwordCheck) {
            setMessage('Jelszavak nem egyeznek');
            return;
        }
        userService.register(user, files)
            .then(() => {
                navigate('/dashboard/users')
                sendAlertMessage('Felhasználó sikeresen hozzáadva!')
            })
            .catch(error => setMessage(error.message))
            .finally(() => setWaitingForServer(false))
    };

    const update = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        userService.updateUser(id, user, files)
            .then(() => {
                retrieveUser()
                setFiles([])
                sendAlertMessage('Módosítások sikeresen mentve!')
            })
            .catch(error => setMessage(error.message))
            .finally(() => setWaitingForServer(false))
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const removeDocumentName = (fileId) => {
        userService.deleteUserFile(id, fileId)
            .then(() => {
                retrieveUser()
                sendAlertMessage('Fájl sikeresen törölve!')
            })
            .catch(error => sendAlertMessage(error.message, 'error'))
    };

    const updateFileDescription = (id, form) => {
        cloudStorageFileService.update(id, form)
            .then(() => {
                retrieveUser()
                sendAlertMessage('Fájl leírása sikeresen módosítva!')
            })
            .catch(error => sendAlertMessage(error.message, 'error'))
    }

    return (
        <RegisterTemplate
            {...{
                id, user, message, onChange, register, update, files, handleFileChange, handleRemoveFile, removeDocumentName, sendAlertMessage, navigate,
                waitingForServer, updateFileDescription
            }}
        />
    );
};

export default UserEditor;
